// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1vi4Y","dragIcon":"Choice_dragIcon__R7JIG","left":"Choice_left__36x9j","input":"Choice_input__8XOIV"};